import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { Modal } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import InputText from 'components/InputText/InputText';
import { AdminService } from 'services/AdminService';
import { useSelector } from 'react-redux';
import { Button, cui, CuiTextArea, InputDropdown, InputRadio } from 'components';
import I18nService from 'components/i18n/I18nService';

const USER = {
  fullname: '', contact_no: '', note: '',
  province_id: '', district_id: '', precinct_id: ''
}

const regexPhoneNumber = /^\+?(?:[0-9]??).{9,12}[0-9]/;

const FormOrder = ({ openForm, closeForm, confirmAction }) => {
  const [userForm, setUserForm] = useState(USER);
  const [error, setError] = useState('');
  const [cycle, setCycle] = useState(1);
  const [locate, setLocate] = useState(1);

  const [listProvinces, setListProvince] = useState([]);
  const [listDistricts, setListDistricts] = useState([]);
  const [listWards, setListWards] = useState([]);
  const [listStreets, setListStreets] = useState([]);
  const [listAreas, setListAreas] = useState([]);
  const [listIncubations, setListIncubations] = useState([]);
  const [showError2, setShowError2] = useState(false);

  const addressObj = useRef({});
  const [addressText, setAdressText] = useState('');

  const intl = useIntl();
  const authorized = useSelector(state => state.authorizedReducer.authorized);

  useEffect(() => {
    if (authorized) {
      getListProvinces();
      setUserForm(prevState => ({
        ...prevState,
        note: I18nService('IDS_TV_YEU_CAU_KHAC_ORDER_1', { intl, x: 1 })
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorized]);

  const getListProvinces = () => {
    AdminService.getProvinces1800({}, res => {
      if (res.error_code === '0') {
        setListProvince(res.transformList);
      }
    });
  }

  const getListDistricts = (province_id) => {
    const data = {
      province_id
    };
    AdminService.getDistricts1800(data, res => {
      if (res.error_code === '0') {
        setListDistricts(res.transformList);
      }
    });
  }

  const getListWards = (district_id) => {
    const data = {
      province_id: userForm.province_id,
      district_id
    };
    AdminService.getWards1800(data, res => {
      if (res.error_code === '0') {
        setListWards(res.transformList);
      }
    });
  }

  const getListStreets = (precinct_id) => {
    const data = {
      province_id: userForm.province_id,
      precinct_id
    };
    AdminService.getStreet1800(data, res => {
      if (res.error_code === '0') {
        setListStreets(res.transformList);
      }
    });
  }

  const getListArea = (precinct_id) => { // Khu
    const data = {
      province_id: userForm.province_id,
      precinct_id
    };
    AdminService.getListArea(data, res => {
      if (res.error_code === '0') {
        setListAreas(res.transformList);
      }
    });
  }

  const getListIncubation = (precinct_id) => { // Ấp
    const data = {
      province_id: userForm.province_id,
      precinct_id
    };
    AdminService.getListIncubation(data, res => {
      if (res.error_code === '0') {
        setListIncubations(res.transformList);
      }
    });
  }

  const handleUserForm = (item, name) => {
    setUserForm(prevState => ({
      ...prevState,
      [name]: !cui.isUndefinedOrNull(item.value) ? item.value : item
    }));
  }

  const handleSelectProvince = (item) => {
    setUserForm(prevState => ({
      ...prevState,
      province_id: item.value,
      district_id: '',
      precinct_id: '',
      street_id: '',
      ap_id: '',
      khu_id: '',
    }));
    addressObj.current = { province: item.text };
    setAdressText(item.text);
    getListDistricts(item.value);
  }

  const handleSelectDistrict = (item) => {
    setUserForm(prevState => ({
      ...prevState,
      district_id: item.value,
      precinct_id: '',
      street_id: '',
      ap_id: '',
      khu_id: '',
    }));

    addressObj.current = {
      province: addressObj.current.province,
      district: item.text,
    };
    setAdressText(`${item.text} - ${addressObj.current.province}`);
    getListWards(item.value);
  }

  const handleSelectWard = (item) => {
    setUserForm(prevState => ({
      ...prevState,
      precinct_id: item.value,
      street_id: '',
      ap_id: '',
      khu_id: '',
    }))

    addressObj.current = {
      province: addressObj.current.province,
      district: addressObj.current.district,
      ward: item.text,
    };
    setAdressText(`${item.text} - ${addressObj.current.district} - ${addressObj.current.province}`);
    getListStreets(item.value);
    getListArea(item.value);
    getListIncubation(item.value);
  }

  const handleStreet = (item) => {
    setUserForm(prevState => ({
      ...prevState,
      street_id: item.value,
      ap_id: '',
      khu_id: '',
    }))
    setAdressText(`${item.text} - ${addressObj.current.ward} - ${addressObj.current.district} - ${addressObj.current.province}`);
  }

  const handleAp = (item) => {
    setUserForm(prevState => ({
      ...prevState,
      ap_id: item.value,
      street_id: '',
      khu_id: '',
    }))
    setAdressText(`${item.text} - ${addressObj.current.ward} - ${addressObj.current.district} - ${addressObj.current.province}`);
  }

  const handleKhu = (item) => {
    setUserForm(prevState => ({
      ...prevState,
      khu_id: item.value,
      street_id: '',
      ap_id: '',
    }))
    setAdressText(`${item.text} - ${addressObj.current.ward} - ${addressObj.current.district} - ${addressObj.current.province}`);
  }

  const handleCycle = (value) => {
    setCycle(value);
    setUserForm(prevState => ({
      ...prevState,
      note: I18nService('IDS_TV_YEU_CAU_KHAC_ORDER_1', { intl, x: value })
    }))
  }

  const isValidate = (obj) => {
    for (let p in obj) {
      if (obj[p] === '' && (p !== 'street_id' && p !== 'ap_id' && p !== 'khu_id')) {
        setShowError2(true);
        return false;
      }
      if (!obj['street_id'] && !obj['ap_id'] && !obj['khu_id']) {
        return false;
      }
    }
    return true;
  }

  const handleSubmit = () => {
    setError(intl.formatMessage({ id: 'IDS_TV_CAN_NHAP_THONG_TIN' }));
    if (isValidate(userForm)) {
      const data = {
        ...userForm,
        address: addressText,
      }
      confirmAction(data);
    }
  }

  return (
    <Modal show={openForm} onHide={closeForm} className="form-order" size="lg">
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='IDS_TV_TAO_DON_HANG' /></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-md-6">
            <InputText
              value={userForm.fullname}
              name="fullname"
              title={intl.formatMessage({ id: 'IDS_ORD_CHUTB' })}
              handleOnChange={handleUserForm}
              errorMsg={userForm.fullname ? '' : error}
              isTwoLine
            />
          </div>
          <div className="col-md-6">
            <InputText
              value={userForm.contact_no}
              name="contact_no"
              title={intl.formatMessage({ id: 'IDS_ORD_DIENTHOAI' })}
              handleOnChange={handleUserForm}
              errorMsg={!userForm.contact_no ? error : !regexPhoneNumber.test(userForm.contact_no) ?
                intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }) : ''}
              isTwoLine
              onlyNumber
            />
          </div>
        </div>

        <InputDropdown
          list={listProvinces}
          handleOnChange={handleSelectProvince}
          value={userForm.province_id}
          title={intl.formatMessage({ id: 'IDS_ORD_TINHTHANH' })}
          placeholder={intl.formatMessage({ id: 'IDS_TV_CHON_TINH_THANH_ORDER' })}
          errorMsg={userForm.province_id ? '' : error}
          isTwoLine
        />
        <InputDropdown
          list={listDistricts}
          handleOnChange={handleSelectDistrict}
          value={userForm.district_id}
          title={intl.formatMessage({ id: 'IDS_ORD_QUANHUYEN' })}
          placeholder={intl.formatMessage({ id: 'IDS_TV_CHON_QUAN_HUYEN_ORDER' })}
          errorMsg={userForm.district_id ? '' : error}
          isTwoLine
        />

        <InputDropdown
          list={listWards}
          handleOnChange={handleSelectWard}
          value={userForm.precinct_id}
          title={intl.formatMessage({ id: 'IDS_ORD_PHUONGXA' })}
          placeholder={intl.formatMessage({ id: 'IDS_TV_CHON_PHUONG_XA' })}
          errorMsg={userForm.precinct_id ? '' : error}
          isTwoLine
        />

        <div className="display-sb mt-2 form-order__wrapper-radio">
          <InputRadio
            value={1}
            handleOnChange={() => setLocate(1)}
            selectedOption={locate}
            title={intl.formatMessage({ id: 'IDS_TV_DUONG_PHO' })}
          />
          <InputRadio
            value={2}
            handleOnChange={() => setLocate(2)}
            selectedOption={locate}
            title={intl.formatMessage({ id: 'IDS_ORD_AP' })}
          />
          <InputRadio
            value={3}
            handleOnChange={() => setLocate(3)}
            selectedOption={locate}
            title={intl.formatMessage({ id: 'IDS_ORD_KHU' })}
          />
        </div>

        <div>
          {locate === 1 &&
            <InputDropdown
              list={listStreets}
              name="street_id"
              handleOnChange={handleStreet}
              value={userForm.street_id}
              title={intl.formatMessage({ id: 'IDS_ORD_DUONGPHO' })}
              placeholder={intl.formatMessage({ id: 'IDS_TV_CHON_DUONG_PHO' })}
              isTwoLine
            />}
          {locate === 2 &&
            <InputDropdown
              list={listIncubations}
              name="ap_id"
              handleOnChange={handleAp}
              value={userForm.ap_id}
              title={intl.formatMessage({ id: 'IDS_ORD_AP' })}
              placeholder={intl.formatMessage({ id: 'IDS_ORD_SP_AP' })}
              isTwoLine
            />}
          {locate === 3 &&
            <InputDropdown
              list={listAreas}
              name="khu_id"
              handleOnChange={handleKhu}
              value={userForm.khu_id}
              title={intl.formatMessage({ id: 'IDS_ORD_KHU' })}
              placeholder={intl.formatMessage({ id: 'IDS_ORD_SP_KHU' })}
              isTwoLine
            />}
          {showError2 && !userForm['street_id'] && !userForm['ap_id'] && !userForm['khu_id'] &&
            <p className="err-msg"><FormattedMessage id='IDS_VUI_LONG_CHON_PHO_AP_KHU' /></p>}
        </div>

        <div className="mt-3"><FormattedMessage id='IDS_TV_CHU_KY_THANH_TOAN' /></div>    
        <div className="display-sb form-order__wrapper-radio">
          <InputRadio
            value={1}
            handleOnChange={() => handleCycle(1)}
            selectedOption={cycle}
            title={intl.formatMessage({ id: 'IDS_TV_CHU_KY_1_THANG' })}
          />
          <InputRadio
            value={6}
            handleOnChange={() => handleCycle(6)}
            selectedOption={cycle}
            title={intl.formatMessage({ id: 'IDS_TV_CHU_KY_6_THANG' })}
          />
          <InputRadio
            value={12}
            handleOnChange={() => handleCycle(12)}
            selectedOption={cycle}
            title={intl.formatMessage({ id: 'IDS_TV_CHU_KY_12_THANG' })}
          />
        </div>

        <div className="row mt-3">
          <div className="col-md-6">
            <CuiTextArea
              value={addressText}
              title={intl.formatMessage({ id: 'IDS_ORD_DIACHI' })}
              placeholder={intl.formatMessage({ id: 'IDS_ORD_TV_DIACHI' })}
              handleOnChange={value => setAdressText(value)}
              errorMsg={userForm.address ? '' : error}
            />
          </div>
          <div className="col-md-6">
            <CuiTextArea
              value={userForm.note}
              name="note"
              title={intl.formatMessage({ id: 'IDS_ORD_YEUCAU' })}
              placeholder={intl.formatMessage({ id: 'IDS_ORD_TV_YEUCAU' })}
              handleOnChange={handleUserForm}
              errorMsg={userForm.note ? '' : error}
            />
          </div>
        </div>
      </Modal.Body >
      <Modal.Footer>
        <Button onClick={handleSubmit} className="confirm-btn">
          <FormattedMessage id='IDS_SCREATEORDERHOANTAT' />
        </Button>
      </Modal.Footer>
    </Modal >
  );
}

export default React.memo(FormOrder);
